export const THEME_NAME = {
  NORMAL: 'normal',
  DARK: 'dark',
};
